export interface ImpactMetric {
  value: string
  label: string
  detail: string
}

export const IMPACT_METRICS: ImpactMetric[] = [
  {
    value: '40%',
    label: 'Faster infrastructure provisioning',
    detail:
      'Hetzner infrastructure automated with Terraform and Ansible, removing manual environment build time.',
  },
  {
    value: '30%',
    label: 'Higher deployment frequency',
    detail:
      'CI workflows shortened feedback loops and accelerated release cycles in a production environment.',
  },
  {
    value: '50%+',
    label: 'Improved security posture',
    detail:
      'Vault, Tailscale and Authentik integrated to eliminate plaintext secrets and centralize identity.',
  },
  {
    value: '25%',
    label: 'Lower mean time to detect',
    detail:
      'Centralized Grafana + ELK observability made incident signal visible faster across the platform.',
  },
]